import { useUserPreferences } from './useUserPreferences';
import { 
  formatDate, 
  formatDateShort, 
  formatDateOnly, 
  formatDateLong, 
  formatTimeOnly, 
  formatRelativeTime,
  toDateTimeLocal,
  fromDateTimeLocal
} from '../utils/dateUtils';

export const useDateFormat = () => {
  const { preferences } = useUserPreferences();

  return {
    formatDate: (dateString: string, options?: any) => formatDate(dateString, preferences, options),
    formatDateTime: (dateString: string) => formatDateShort(dateString, preferences),
    formatDateShort: (dateString: string) => formatDateShort(dateString, preferences),
    formatDateOnly: (dateString: string) => formatDateOnly(dateString, preferences),
    formatDateLong: (dateString: string) => formatDateLong(dateString, preferences),
    formatTimeOnly: (dateString: string) => formatTimeOnly(dateString, preferences),
    formatRelativeTime: (dateString: string) => formatRelativeTime(dateString, preferences),
    toDateTimeLocal: (dateString: string) => toDateTimeLocal(dateString, preferences),
    fromDateTimeLocal: (dateString: string) => fromDateTimeLocal(dateString, preferences),
    preferences
  };
};
